// ─────────────────────────────────────────────────────────────────
// Yard Capacity Utilization Types — Matching Xamarin DTOs exactly
// ─────────────────────────────────────────────────────────────────

/** UI model — PascalCase for component consumption */
export interface YardCapacityUtilization {
  DockDoorCapacity: string;
  DockDoorCapacityUtilization: string;
  DockDoorSpaceInUse: string;
  DockDoorSpaceOpen: string;
  DockDoorSpaceUnavailable: string;
  OrgId: string;
  TotalCapacity: string;
  TotalCapacityUtilization: string;
  TotalSpaceInUse: string;
  TotalSpaceOpen: string;
  TotalSpaceUnavailable: string;
  YardCapacity: string;
  YardCapacityUtilisation: string;
  YardSpaceInUse: string;
  YardSpaceOpen: string;
  YardSpaceUnavailable: string;
}

// ─────────────────────────────────────────────────────────────────
// OIC Response Types — Matches actual API response
// Endpoint: NBL_YMS_GET_YRD_CAP_UTILI/1.0/getCapacityUtilization
// Note: OIC returns lowercase "payload" and underscore_case fields in "Data"
// ─────────────────────────────────────────────────────────────────

/** Raw DTO from OIC — underscore_case field names matching API response */
export interface YardCapacityUtilizationDTO {
  Dock_Door_Capacity: string;
  Dock_Door_Capacity_Utilization: string;
  Dock_Door_Space_In_Use: string;
  Dock_Door_Space_Open: string;
  Dock_Door_Space_Unavailable: string;
  Org_id: string;
  Total_Capacity: string;
  Total_Capacity_Utilization: string;
  Total_Space_In_Use: string;
  Total_Space_Open: string;
  Total_Space_Unavailable: string;
  Yard_Capacity: string;
  Yard_Capacity_Utilization: string;
  Yard_Space_In_Use: string;
  Yard_Space_Open: string;
  Yard_Space_Unavailable: string;
}

/** OIC response wrapper — note lowercase "payload" */
export interface OICYardCapacityResponse {
  payload: {
    TransmissionHeader: {
      TransmissionDateTime: string;
      OriginatingSystem: string;
      TransmissionUser: string;
      RoutingCode: string;
      MessageType: string;
      MessageId: string;
    };
    Body: {
      Success: string;
      Message: string;
      Message_Key: string;
      Data: YardCapacityUtilizationDTO | null;
    };
  };
}

/** Request trace data — matches Xamarin RequestTraceDataDTO */
export interface YardCapacityTraceData {
  User: string;
  Plant: string;
  SessionId: string;
}

/** Maps underscore_case DTO to PascalCase UI model */
export function mapYardCapacityUtilization(
  dto: YardCapacityUtilizationDTO
): YardCapacityUtilization {
  return {
    DockDoorCapacity: dto.Dock_Door_Capacity,
    DockDoorCapacityUtilization: dto.Dock_Door_Capacity_Utilization,
    DockDoorSpaceInUse: dto.Dock_Door_Space_In_Use,
    DockDoorSpaceOpen: dto.Dock_Door_Space_Open,
    DockDoorSpaceUnavailable: dto.Dock_Door_Space_Unavailable,
    OrgId: dto.Org_id,
    TotalCapacity: dto.Total_Capacity,
    TotalCapacityUtilization: dto.Total_Capacity_Utilization,
    TotalSpaceInUse: dto.Total_Space_In_Use,
    TotalSpaceOpen: dto.Total_Space_Open,
    TotalSpaceUnavailable: dto.Total_Space_Unavailable,
    YardCapacity: dto.Yard_Capacity,
    YardCapacityUtilisation: dto.Yard_Capacity_Utilization,
    YardSpaceInUse: dto.Yard_Space_In_Use,
    YardSpaceOpen: dto.Yard_Space_Open,
    YardSpaceUnavailable: dto.Yard_Space_Unavailable,
  };
}
